module.exports = __webpack_public_path__ + "img/review-us-on-facebook.6c4cfffa.png";